// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/service_priorities/remover
 *
 * Soft-delete a service-priority row.
 */
import { registerContract } from './validate'

export interface ServicePriorities_RemoverInput {
so_service_priority_id: number
}

registerContract('ServicePriorities_RemoverInput', {
  so_service_priority_id: { type: 'number',  required: true },
})
